export const FIELDS = [
  {
    name: 'aurisTicketId',
    label: 'N° requerimiento',
    disabled: true,
    required: true,
  },
  {
    name: 'rut',
    label: 'RUT',
    disabled: true,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'nombre_cli',
    label: 'Nombre completo',
    disabled: true,
    required: true,
  },
  {
    name: 'telefono',
    label: 'Teléfono',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'correo',
    label: 'Correo',
    disabled: false,
    required: true,
  },
  {
    name: 'oc',
    label: 'N° de orden de compra',
    disabled: true,
    required: true,
    helper: 'Ingresar 8 o 9 dígitos',
  },
  {
    name: 'cud',
    label: 'Cud',
    disabled: true,
    required: true,
  },
  {
    name: 'bank',
    label: 'Banco',
    disabled: false,
    required: true,
    inputType: 'select',
  },
  {
    name: 'accountNumber',
    label: 'Número de cuenta',
    disabled: false,
    required: true,
  },
  {
    name: 'rutOwner',
    label: 'RUT titular de la cuenta',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'nameOwner',
    label: 'Nombre titular de la cuenta',
    disabled: false,
    required: true,
  },
  {
    name: 'state',
    label: 'Región',
    disabled: false,
    required: true,
    inputType: 'select',
  },
  {
    name: 'city',
    label: 'Comuna',
    disabled: false,
    required: true,
    inputType: 'select',
  },
  {
    name: 'cancelAddress',
    label: 'Dirección',
    disabled: false,
    required: true,
  },
];
